<template>
  <div>

    <!--    <mdb-container class="mb-5">
          <section class="text-center z-depth-1">
            <mdb-row class="text-center">
              <mdb-col md="12" class="mb-lg-0 mb-4">
                <mdb-view class="overlay rounded z-depth-1">
                  <img src="../assets/images/cy/3.jpg" alt="sample photo" class="img-fluid mx-auto"/>
                  <a>
                    <mdb-mask waves overlay="white-slight"/>
                  </a>
                </mdb-view>
                <mdb-card-body class="pt-4 pb-2" v-animateOnScroll="{animation: 'rotateInDownLeft', delay: 0}">
                  <h4 class="font-weight-bold">塞浦路斯护照移民</h4>
                  <p class="dark-grey-text"> 无学历、语言、工作经验、商业背景要求<br/>8-10个月获批护照，“0”拒签率<br/>一人申请，全家三代人同时获批<br/>无居住要求，只需获批登陆领取
                  </p>
                  <mdb-btn color="primary" @click="$router.push('/cy')">
                    <mdb-icon icon="clone" class="left"/>
                    查看详情
                  </mdb-btn>
                </mdb-card-body>
              </mdb-col>

            </mdb-row>
          </section>
        </mdb-container>-->


    <mdb-container class="mb-5">
      <section class="text-center z-depth-1">
        <mdb-row class="text-center">
          <mdb-col md="12" class="mb-lg-0 mb-4">
            <mdb-view class="overlay rounded z-depth-1">
              <img src="../assets/images/hk/3.jpg" alt="sample photo" class="img-fluid mx-auto"/>
              <a>
                <mdb-mask waves overlay="white-slight"/>
              </a>
            </mdb-view>
            <mdb-card-body class="pt-4 pb-2" v-animateOnScroll="{animation: 'rotateInDownLeft', delay: 0}">
              <h4 class="font-weight-bold">香港专才移居</h4>
              <p class="dark-grey-text"> 无需投资<br/>申请流程快，1-3个月即可获批<br/>居住满7年后可申请成为香港永久居民<br/>香港护照免签164个国家和地区
              </p>
              <mdb-btn color="primary" @click="$router.push('/hk')">
                <mdb-icon icon="clone" class="left"/>
                查看详情
              </mdb-btn>
            </mdb-card-body>
          </mdb-col>

        </mdb-row>
      </section>
    </mdb-container>

    <mdb-container class="mb-5">
      <section class="text-center z-depth-1">
        <mdb-row class="text-center">
          <mdb-col md="12" class="mb-lg-0 mb-4">
            <mdb-view class="overlay rounded z-depth-1">
              <img src="../assets/images/jp/3.jpg" alt="sample photo" class="img-fluid mx-auto"/>
              <a>
                <mdb-mask waves overlay="white-slight"/>
              </a>
            </mdb-view>
            <mdb-card-body class="pt-4 pb-2" v-animateOnScroll="{animation: 'rotateInDownLeft', delay: 0}">
              <h4 class="font-weight-bold">日本投资移民</h4>
              <p class="dark-grey-text"> 永久产权<br/>可购买土地<br/>可联名/公司/个人购买<br/>无公摊，阳台赠送
              </p>
              <mdb-btn color="info" @click="$router.push('/jp')">
                <mdb-icon icon="clone" class="left"/>
                查看详情
              </mdb-btn>
            </mdb-card-body>
          </mdb-col>

        </mdb-row>
      </section>
    </mdb-container>


    <mdb-container class="mb-5">
      <section class="text-center z-depth-1">
        <mdb-row class="text-center">
          <mdb-col md="12" class="mb-lg-0 mb-4">
            <mdb-view class="overlay rounded z-depth-1">
              <img src="../assets/images/ptg/3.jpg" alt="sample photo" class="img-fluid mx-auto"/>
              <a>
                <mdb-mask waves overlay="white-slight"/>
              </a>
            </mdb-view>
            <mdb-card-body class="pt-4 pb-2" v-animateOnScroll="{animation: 'rotateInDownLeft', delay: 0}">
              <h4 class="font-weight-bold">葡萄牙35万欧基金移民</h4>
              <p class="dark-grey-text"> 门槛低、入籍更快、成本更低<br/>一人申请三代获批<br/>无语言要求，无需蹲坐移民监<br/>无公摊，阳台赠送
              </p>
              <mdb-btn color="info" @click="$router.push('/ptg')">
                <mdb-icon icon="clone" class="left"/>
                查看详情
              </mdb-btn>
            </mdb-card-body>
          </mdb-col>

        </mdb-row>
      </section>
    </mdb-container>

    <mdb-container class="mb-5">
      <section class="text-center  z-depth-1">
        <mdb-row class="text-center">
          <mdb-col md="12" class="mb-lg-0 mb-4">
            <mdb-view class="overlay rounded z-depth-1">
              <img src="../assets/images/gr/3.jpg" alt="sample photo" class="img-fluid mx-auto"/>
              <a>
                <mdb-mask waves overlay="white-slight"/>
              </a>
            </mdb-view>
            <mdb-card-body class="pt-4 pb-2" v-animateOnScroll="{animation: 'slideInDown', delay: 0}">
              <h4 class="font-weight-bold">希腊25万欧元购房移民</h4>
              <p class="dark-grey-text"> 仅需25万欧元购房，一步到位获得绿卡<br/>无需体检、面试、无语言要求、无商业背景要求<br/>递交材料后最快两个月获批，拿申根国永居身份</p>
              <mdb-btn color="danger" @click="$router.push('/gr')">
                <mdb-icon icon="clone" class="left"/>
                查看详情
              </mdb-btn>
            </mdb-card-body>
          </mdb-col>

        </mdb-row>
      </section>
    </mdb-container>

  </div>

</template>

<script>
import { animateOnScroll } from 'mdbvue'

export default {
  name: 'HomeOthers',
  directives: {
    animateOnScroll
  }
}
</script>

<style>
.opacityOuterUsa {
  background: rgba(0, 0, 0, 0.1) !important;
  background: #fff;
  filter: Alpha(opacity=10);
}
</style>
